import { Component } from 'react'

import { Taxonomy } from './Taxonomies/Taxonomy'

export class Taxonomies extends Component {

	constructor( props ) {
		super( props )

		this.state = {
			'taxonomies' : this.getNestedTaxonomies( this.props.taxonomies )
		}

		this.addTermToQuery = this.addTermToQuery.bind( this )
		this.removeTermFromQuery = this.removeTermFromQuery.bind( this )
	}

	componentDidUpdate( prevProps, prevState ) {
		if ( prevProps.taxonomies !== this.props.taxonomies ) {
			let nestedTaxonomies = this.getNestedTaxonomies( this.props.taxonomies )
			this.setState({ taxonomies: nestedTaxonomies })
		}
	}

	/**
	 * Takes an array of taxonomies and returns them back with their terms in a
	 * nested format
	 * 
	 * @param  {array} taxonomies Initial array of taxonomies
	 * @return {array}            Modified array of taxonomies
	 */
	getNestedTaxonomies( taxonomies ) {
		taxonomies.forEach( taxonomy => {
			if ( 'undefined' !== typeof taxonomy.terms && taxonomy.terms.length ) {
				taxonomy.terms = this.getNestedTerms( taxonomy.terms )
			}
		})

		return taxonomies
	}

	/**
	 * Takes a flat array of term objects from WordPress and nests children terms
	 * under it's parent term
	 *
	 * @param  {array}  terms Array of WP_Term objects
	 * @return {object}       Nested term_id -> term object of terms.
	 */
	getNestedTerms( terms ) {
		let termsByID = {}
		let parents = []
		let childrenByParentID = {}

		/**
		 * Recursive function to populate the children for the term provided.
		 */
		function populateChildren( term ) {
			var children

			/** If the given term has children (IDs are stored in childrenByParentID) */
			if ( children = childrenByParentID[ term.term_id ] ) {
				children.forEach( childID => {
					if ( ! term.children ) {
						term.children = {}
					}

					term.children[ childID ] = termsByID[ childID ]

					populateChildren( termsByID[ childID ] )
				})
			}
		}

		/**
		 * Loop through the terms and...
		 * 1. Build a term_id -> term pairing (termsByID)
		 * 2. Build an array of top level (parents)
		 * 3. Build a parent -> array of term_ids pairing (childrenByParentID)
		 */
		terms.forEach( term => {
			termsByID[ term.term_id ] = term

			if ( 0 == term.parent ) {
				parents.push( term.term_id )
			} else {
				if ( ! childrenByParentID[ term.parent ] ) {
					childrenByParentID[ term.parent ] = []
				}

				childrenByParentID[ term.parent ].push( term.term_id )
			}
		});

		let nestedTerms = {}

		/* Build a nested object of taxonomies by using our recursive function populateChildren */
		parents.forEach( parentID => {
			let parent = termsByID[ parentID ]
			nestedTerms[ parentID ] = parent
			populateChildren( parent )
		});

		return nestedTerms
	}

	addTermToQuery( term_slug, taxonomy_slug ) {
		let taxFilter = this.props.filters.tax

		if ( ! taxFilter[ taxonomy_slug ] ) {
			taxFilter[ taxonomy_slug ] = [ term_slug ]
		} else {
			taxFilter[ taxonomy_slug ].push( term_slug )
		}

		this.props.updateFilter( 'tax', taxFilter )
	}

	removeTermFromQuery( term_slug, taxonomy_slug ) {
		let taxFilter = this.props.filters.tax

		if ( ! taxFilter[ taxonomy_slug ] ) {
			return
		} else {
			let index = taxFilter[ taxonomy_slug ].indexOf( term_slug )
			if ( index > -1 ) {
				taxFilter[ taxonomy_slug ].splice( index, 1 )
			}

			// If there are no more terms in the filter, remove it
			if ( ! taxFilter[ taxonomy_slug ].length ) {
				delete taxFilter[ taxonomy_slug ]
			}
		}

		this.props.updateFilter( 'tax', taxFilter )
	}

	getActiveTerms( taxonomy, filters ) {
		return ( filters.tax.hasOwnProperty( taxonomy ) ) ? filters.tax[ taxonomy ] : [];
	}

	render() {
		return (
			<div className="pf-filter-bar__taxonomies">
				{this.state.taxonomies.map(( taxonomy, taxonomyID ) => {

					let activeTerms = this.getActiveTerms( taxonomy.name, this.props.filters )
					return (
						<Taxonomy 
							addTermToQuery={ this.addTermToQuery } 
							removeTermFromQuery={ this.removeTermFromQuery } 
							taxonomy={ taxonomy } 
							key={ taxonomyID } 
							showList={ this.props.showTaxList }
							activeTerms={ activeTerms }
						/>
					)
				})}
			</div>
		)
	}

}